import React from 'react'
import PaymentForm from '../../../shared/payment-form'

// Paying for a change to an existing booking.
//
// This used to render booking/payment-form, the older of the two payment forms in the app,
// which has no wallet support -- so a guest could pay for the original booking with Apple or
// Google Pay and then be asked for card details to change it. shared/payment-form is the one
// checkout, add-ons and split-the-bill already use, so moving here means one wallet-capable
// form rather than two that drift.
//
// The before -> after summary is rendered server-side above this component
// (shared/_amendment_changes), so there is one description of a change across the wizard, the
// booking page and the emails. This component owns the money only.
const AmendmentPayment = ({ config, amendment }) => {

	return (
		<PaymentForm
			amount={amendment.amountToPay}
			expressEnabled={config.payment.express_enabled === true}
			token={config.token}
			auth={config.auth}
			config={config.payment}
			shortForm={false}
			additionalFields={null}
			additionalFormData={() => { return [] }}
			getPaymentData={( cardFormData ) => {
				// The wallet path has no card form to read a name off, so fall back to the
				// account holder. genPostParams sends whatever comes back from here.
				return {
					firstname: cardFormData && cardFormData.cardFirstname ? cardFormData.cardFirstname.value : config.auth.firstname,
					lastname: cardFormData && cardFormData.cardLastname ? cardFormData.cardLastname.value : config.auth.lastname,
					postcode: cardFormData && cardFormData.cardPostcode ? cardFormData.cardPostcode.value : config.auth.postcode,
					// The server re-reads the amendment from the database and prices it there;
					// this is carried only so the payment row can be attributed.
					deposit: amendment.isDepositPayment ? 1 : 0
				}
			}}
			raiseErrors={false}
			sendErrors={null}
			terms={false}
			tracking={false}
		/>
	)
}

export default AmendmentPayment
